<template>
  <section class="est-room__section">
    <label class="est-room__label" for="meetingInviteUrl">{{ $t('OnlineMeetingComponent.MeetingLink') }}</label>
    <div class="est-room__invite">
      <input id="meetingInviteUrl"
             ref="url"
             type="text"
             class="form-control est-room__invite-url"
             :value="meetingUrl"
             readonly
             @focus="$event.target.select()">
      <button type="button"
              class="btn btn-outline-secondary est-room__invite-copy"
              :title="$t('CopyLink')"
              :aria-label="$t('CopyLink')"
              @click="copyClipboard">
        <font-awesome-icon :icon="copied ? 'fa-solid fa-check' : 'fa-solid fa-copy'" />
      </button>
    </div>
    <p class="est-room__hint">{{ $t('OnlineMeetingComponent.VegaInviteHint') }}</p>
  </section>
</template>

<script>
  // Davet kartı bir paylaşım menüsü değildir: salt okunur bağlantı + kopyala.
  // Yalnız host, danışan odaya gelmeden basılır.
  export default {
    name: 'MeetingInvitationComponent',
    props: {
      meetingUrl: String
    },
    data() {
      return {
        copied: false
      }
    },
    methods: {
      async copyClipboard() {
        try {
          // `document.execCommand('copy')` kullanımdan kalktı ve bazı tarayıcılarda
          // sessizce başarısız oluyor; panoya erişilemeyen bağlamda (izin yok, http)
          // seçili input'a düşülür — kullanıcı en azından elle kopyalayabilir.
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.meetingUrl);
          } else {
            this.$refs.url.select();
            throw new Error("clipboard-unavailable");
          }

          this.copied = true;
          this.$toastr.success(this.$t("Copied"));
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        } catch (error) {
          console.error(error);
          this.$refs.url.select();
          this.$toastr.warning(this.$t("OnlineMeetingComponent.CopyLinkFailed"));
        }
      }
    }
  }
</script>
